const castAsNumber = (val) => (val ? Number.parseFloat(val, 10) : 0);

export default castAsNumber;
